module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_Andriod.66e65.png";